import { RISK_CONFIG, RISK_SCALE_ORDER } from "../../constants/riskConfig";

/**
 * The five-step risk ramp.
 *
 * Drawn in RISK_SCALE_ORDER (Very Low → Very High, left to right) so the
 * marketing site reads the same direction as the map legend and the in-app
 * RiskScale. Steps up to and including `reachedScore` are full strength and
 * the rest drop to 30%, matching /app's "colour every step, dim the unreached
 * ones" treatment. Pass no `reachedScore` to draw the full ramp.
 */
export default function RiskStrip({ reachedScore, barClassName = "h-2", className = "" }) {
  const reachedIndex =
    reachedScore == null ? -1 : RISK_SCALE_ORDER.indexOf(String(reachedScore));

  return (
    <div className={`flex gap-[3px] ${className}`}>
      {RISK_SCALE_ORDER.map((score, index) => (
        <span
          key={score}
          className={`flex-1 rounded-[2px] ${barClassName}`}
          style={{
            backgroundColor: RISK_CONFIG[score].hex,
            opacity: reachedIndex === -1 || index <= reachedIndex ? 1 : 0.3,
          }}
        />
      ))}
    </div>
  );
}
